export const COLLECTION = "ApexDucks";

export function imageForNft(nft: number) {
    return 'https://nft-images.netlify.app/ApexDucks/image-' + nft + '-75.png';
}